@let loading = selectIsStepsLoadingSig();
@let viewState = viewStateSig();

@if(loading) {
    <ui-preloader [color]="preloaderColor.blue"></ui-preloader>
}@else {
    @switch (viewState) {
        @case (viewStates.INITIAL_EMPTY) {
            <ui-no-data [imgSrc]="noData.imgSrc"
                        [title]="noData.title|translate">
            </ui-no-data>
        }
        @case (viewStates.HAS_CONTENT) {
            <div class="w-100 h-100">
                <div class="chart">
                    <canvas #chartCanvas></canvas>
                </div>
            </div>
        }
    }
}